export const GROUP_TYPES = [
  { id: 'ldap', value: 'ldapGroup' },
  { id: 'posix', value: 'posixGroup' },
  { id: 'ant', value: 'antGroup' },
];
